export const ITEM_ELIGIBILITY_OPTIONS = [
  { value: 'all', label: 'Everyone' },
  { value: 'first_booking', label: 'First booking only' },
  { value: 'returning_customer', label: 'Returning customer (2nd cleaning onward)' },
];

export const getItemEligibilityLabel = (value) =>
  ITEM_ELIGIBILITY_OPTIONS.find((option) => option.value === (value || 'all'))?.label || 'Everyone';

export const isItemEligible = (item, isFirstBooking) => {
  const eligibility = item?.eligibility_type || 'all';
  if (eligibility === 'all' || typeof isFirstBooking !== 'boolean') return true;
  if (eligibility === 'first_booking') return isFirstBooking;
  if (eligibility === 'returning_customer') return !isFirstBooking;
  return true;
};
